<script>
  import { createEventDispatcher } from 'svelte';
  import { InlineNotification, Modal } from 'carbon-components-svelte';

  import LoadingSpinner from '../../components/LoadingSpinner.svelte';

  import { getServerErrorMessage } from '../../utils';
  import { enableAtfHttpsAccess, revokeAtfHttpsAccess } from '../../services';

  const dispatch = createEventDispatcher();

  export let open = false,
    groupId,
    user;

  let resultNotification,
    loading = false;

  async function onFormSubmit() {
    resultNotification = null;
    loading = true;

    try {
      const handler = hasAccess ? revokeAtfHttpsAccess : enableAtfHttpsAccess;
      await handler(groupId, user.id);

      dispatch('submit');
      dispatch('close');
    } catch (error) {
      const errorMessage = getServerErrorMessage(error) ?? 'Verify your submission and try again!';
      console.error('[ATFAccessModal] Failed to change user ATF status!', errorMessage);
      resultNotification = {
        kind: 'error',
        title: 'Error:',
        subtitle: `Failed to change user ATF status! ${errorMessage}`,
      };
    } finally {
      loading = false;
    }
  }

  function handleClose() {
    if (loading) {
      return;
    }

    dispatch('close');
  }

  $: hasAccess = user.atfAccess?.userId === user.id && user.atfAccess?.groupId === groupId;
</script>

<Modal
  bind:open
  size="sm"
  danger={hasAccess}
  modalHeading={`${hasAccess ? 'Revoke' : 'Enable'} AWS Transfer Family HTTPS Access`}
  primaryButtonText={hasAccess ? 'Revoke' : 'Enable'}
  secondaryButtonText="Cancel"
  shouldSubmitOnEnter={false}
  primaryButtonDisabled={loading}
  on:click:button--secondary={handleClose}
  on:close={handleClose}
  on:submit={onFormSubmit}
>
  <LoadingSpinner {loading} small showOverlay>
    {#if resultNotification}
      <InlineNotification
        kind={resultNotification.kind}
        lowContrast
        title={resultNotification.title}
        subtitle={resultNotification.subtitle}
        hideCloseButton
      />
    {/if}
    <p>
      Are you sure you want to {hasAccess ? 'revoke' : 'enable'} AWS Transfer Family Web Application access for
      <strong>{user.email}?</strong>
    </p>
  </LoadingSpinner>
</Modal>
